import React from "react"
import posed, { PoseGroup } from "react-pose"

const Criterion = ({ style, description, met }) => (
  <div style={style} className={"criterion" + (met ? " conditionMet" : "")}>
    {met ? <i>✓</i> : <i>✖</i>}
    <span>{description}</span>
  </div>
);

const PosedLi = posed.li({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
});

const PasswordHelper = ({ criteria }) => {
  const satisfiedCriteria = [];
  const unsatisfiedCriteria = [];

  criteria.forEach((criterion, i) => {
    const newCriterionComponent = (
      <PosedLi key={i}>
        <Criterion
          flipMove={false}
          met={criterion.value}
          description={criterion.description}
        />
      </PosedLi>
    );
    criterion.value
      ? satisfiedCriteria.push(newCriterionComponent)
      : unsatisfiedCriteria.push(newCriterionComponent);
  });

  return (
    <div>
      <ul className="password-helper">
        <PoseGroup>
          {unsatisfiedCriteria}
          {unsatisfiedCriteria ? <hr key={"hr"} /> : null}
          {satisfiedCriteria}
        </PoseGroup>
      </ul>
    </div>
  );
};

export default PasswordHelper;
